import React from 'react';
import { PapiDeviation } from '@wix/da-types-papi';
import { useTranslation } from 'react-i18next';
import LoadableDuperbrowseContext from '../../../../../contexts/LoadableDuperbrowseContext';
import FreeformHugeThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Huge/Freeform';
import EmptyState from '../../_partials/EmptyState';
import PostEditableItem from '../../../../UserWidgets/_partials/PostEditableItem';

import s from './JournalsList.scss';

export interface Props {
  streamId: string;
  items: PapiDeviation[];
}

const JournalsList: React.FC<Props> = ({ items, streamId }) => {
  const { t } = useTranslation();
  if (!items.length) {
    return <EmptyState view="large" postType="journal" />;
  }

  return (
    <div className={s['root']}>
      <LoadableDuperbrowseContext
        streamId={streamId}
        parent={{ title: t('navigation.route.posts') }}
      >
        {items.map((item, i) => (
          <PostEditableItem
            key={`journal-${i}-${item.deviationId}`}
            className={s['item']}
            item={item}
          >
            <FreeformHugeThumb deviation={item} />
          </PostEditableItem>
        ))}
      </LoadableDuperbrowseContext>
    </div>
  );
};
JournalsList.displayName = 'JournalsList';

export default JournalsList;
